import { IReportFilter, IReportParameter } from './filter.types'

/** class for Report filters */
export class ReportFilter implements IReportFilter {
    Name: string
    Field: string
    Type: string
    DataType: string
    Items: any 

    constructor(filter: IReportFilter) {
        this.Name = filter.Name;
        this.Field = filter.Field;
        this.Type = filter.Type;
        this.DataType = filter.DataType;
        this.Items = filter.Items
    }
}

export class ReportParameter implements IReportParameter {
    Name: string
    Field: string
    Type: string
    DataType: string
    Operator: string
    Values: any

    constructor(params: IReportParameter) {
        this.Name = params.Name;
        this.Field = params.Field;
        this.Type = params.Type;
        this.DataType = params.DataType;
        this.Operator = params.Operator;
        this.Values = params.Values;
    }
}